import React from 'react';
import './index.scss';

export function Checkbox({ isChecked, onChange, label }) {
    return (
        <label className="custom-checkbox">
            <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => onChange(e)}
            />
            {label}
        </label>
    );
}